import { safeLocalStorage } from '@/lib/safeLocalStorage';
import { THEME_PREFERENCE_VALUES } from '@/styles/constants';
import type { ThemePreferenceType, ThemePreferenceValue } from '@/styles/types';
import { useEffect } from 'react';

const STORAGE_KEY = 'ui.theme-preference';

export const useSyncTheme = (
  themePreference: ThemePreferenceType | undefined,
  themePreferenceValue: ThemePreferenceValue | undefined
): void => {
  const applyThemeValue = (
    preference: ThemePreferenceType,
    value: ThemePreferenceValue
  ): void => {
    if (value === THEME_PREFERENCE_VALUES.LIGHT) {
      window.document.documentElement.classList.remove(
        THEME_PREFERENCE_VALUES.DARK
      );
    } else {
      window.document.documentElement.classList.add(value);
    }
    // Gate: skip write when localStorage already holds the incoming value.
    if (safeLocalStorage.getItem(STORAGE_KEY) !== preference) {
      safeLocalStorage.setItem(STORAGE_KEY, preference);
    }
  };

  useEffect(() => {
    if (themePreference && themePreferenceValue) {
      applyThemeValue(themePreference, themePreferenceValue);
    }
  }, [themePreference, themePreferenceValue]);
};
